<template>
    <el-dialog v-dialogDrag  class="dialog" width="500px"
               :visible.sync="dialogVisible" v-loading="dialoading"
               :close-on-click-modal="false"
               top="30vh" @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                修改密码
            </div>
        </div>
        <div class="dialog_body">
            <el-form ref="formData" v-loading="loading"  label-width="120px"
                     style="padding: 15px;padding-top: 10px">
                <el-form-item label="旧密码" >
                    <el-input v-model="oldPassword" show-password placeholder="请输入旧密码"></el-input>
                </el-form-item>
                <el-form-item label="新密码" >
                    <el-input v-model="newPassword" show-password placeholder="请输入新密码"></el-input>
                </el-form-item>
                <el-form-item label="确认新密码" >
                    <el-input v-model="newRPassword" show-password placeholder="请输入新密码"></el-input>
                </el-form-item>
            </el-form>

            <div style="text-align: center;padding: 10px 0px 20px 0px">
                <el-button type="danger" @click="close">取 消</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>

    export default {
        name: "editDialog",
        props: ['loading'],
        data() {
            return {
                dialoading: this.loading,
                oldPassword:"",
                newPassword:"",
                newRPassword:"",
                dialogVisible: true,
                formLabelWidth: '80px',
            };
        },
        mounted() {
        },
        methods: {
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            async submitForm() {
                if(this.oldPassword==null || this.oldPassword==''){
                    this.$message({message: '请输入旧密码', type: 'error'});
                    return false;
                }
                if(this.newPassword==null || this.newPassword==''){
                    this.$message({message: '请输入新密码', type: 'error'});
                    return false;
                }
                if(this.newRPassword==null || this.newRPassword==''){
                    this.$message({message: '请输入确认新密码', type: 'error'});
                    return false;
                }

                if(this.newRPassword!=this.newPassword){
                    this.$message({message: '两次密码不一致', type: 'error'});
                    return false;
                }

                let param = {
                    userId:this.$store.state.loginInfo.user.userId,
                    oldPassword:this.oldPassword,
                    newPassword:this.newPassword,
                }
                const data = await this.$sqlOpt.save.saveNoToken(param, "/user/saveNewPassword");
                if (data.infoCode === '0') {
                    this.$message.success("密码修改成功");
                    this.$emit('closeDialog', this.dialogVisible);
                }
                this.loading = false;
            },
        }
    }
</script>

